import {
  Box,
  Grid,
  GridItem,
  Text,
  Flex,
  Icon,
  Button,
  Link,
  Stack,
} from '@chakra-ui/react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import moment from 'moment';
import ModalReviewPengetahuan from '../../../components/Pengetahuan/ModalReview.';
import ListTemaPengetahuan from '../../../components/Pengetahuan/ListTema';
import ReviewPengetahuan from '../../../components/Pengetahuan/Review';
import ReviewDiskusiTabs from '../../../components/Pengetahuan/ReviewDiskusiTabs';
import { PengetahuanItem } from '../../../../types/pengetahuan';

type Props = {
  pengetahuanItem: PengetahuanItem | null;
};

const PengetahuanSelesaiSection = ({ pengetahuanItem }: Props) => {

  return (
    <Grid templateColumns="repeat(7, 1fr)" gap={5}>
      <GridItem colSpan={{ base: 7, md: 4 }}>
        <Box rounded="lg" w="full" p={4} bg="white" mt={4}>
          <Text fontSize="lg" fontWeight="semibold" mb={2}>
            Selamat Kamu Telah Selesai Mengikuti Pengetahuan Ini!
          </Text>
          <Text fontSize="sm" color="gray.400" mb={4}>
            Terus Belajar dan praktikan ilmu yang telah anda pelajari di
            pengetahuan ini agar lebih bermanfaat{' '}
          </Text>
          <Stack direction="row" spacing={4}>
            {pengetahuanItem?.path_certificate_url && (
              <Button
                as={Link}
                href={pengetahuanItem.path_certificate_url}
                download
                colorScheme="orange"
                isExternal
                _hover={{ textDecoration: 'none' }}
              >
                Unduh Sertifikat
              </Button>
            )}
            {!pengetahuanItem?.has_reviewed && <ModalReviewPengetahuan />}
          </Stack>
        </Box>

        {pengetahuanItem?.jenis_pengetahuan === 'synchronized' && pengetahuanItem?.pengetahuan_materi_saya && (
          <Box rounded="lg" w="full" p={4} bg="white" mt={4}>
            <Text fontSize="lg" fontWeight="semibold" mr={2} mb={2}>
              Materi yang telah kamu pelajari
            </Text>
            <Box>
              <Stack direction="row" spacing={1}>
                <Text fontWeight="semibold" fontSize="md">
                  {pengetahuanItem?.pengetahuan_materi_saya?.nama_pemateri} |
                </Text>
                <Text fontSize="md">Pemateri</Text>
              </Stack>
              <Text fontSize="sm" mt={2}>
                {pengetahuanItem?.pengetahuan_materi_saya?.judul}
              </Text>
              <Stack direction="row" mt={2} spacing={2}>
                {pengetahuanItem?.pengetahuan_materi_saya?.has_quiz && (
                  <Flex alignItems="center">
                    <Text fontSize="sm" color="gray.500" mr={2}>
                      Nilai Quiz:
                    </Text>
                    <Text fontSize="sm" fontWeight="500" color="green.600">
                      {pengetahuanItem.nilai_quiz}
                    </Text>
                  </Flex>
                )}
              </Stack>
              <Stack direction="row" mt={2} spacing={2}>
                {pengetahuanItem?.pengetahuan_materi_saya
                  ?.t_pengetahuan_asesmen?.selesai_pada && (
                  <Flex alignItems="center">
                    <Text fontSize="sm" color="gray.500" mr={2}>
                      Status Asesmen:
                    </Text>
                    <Text fontSize="sm" fontWeight="500" color="green.600">
                      Selesai Dikerjakan
                    </Text>
                  </Flex>
                )}
              </Stack>
            </Box>
          </Box>
        )}

        <Box rounded="lg" w="full" p={4} bg="white" mt={4}>
          <Flex alignItems="center">
            <Text fontSize="lg" fontWeight="semibold" mr={2}>
              Informasi Umum
            </Text>
          </Flex>
          <Flex alignItems="center" mt={2}>
            <Icon as={AiOutlineClockCircle} boxSize={4} mr={2} />
            <Text fontSize="sm">
              {moment(pengetahuanItem?.created_at, 'YYYY-MM-DD HH:mm:ss').fromNow()}
            </Text>
          </Flex>
          <Box
            mt={4}
            as="div"
            dangerouslySetInnerHTML={{
              __html: pengetahuanItem?.description || '',
            }}
          ></Box>
        </Box>
      </GridItem>

      <GridItem colSpan={{ base: 7, md: 3 }}>
        {pengetahuanItem?.is_klinik_khusus && (
          <ListTemaPengetahuan
            data={
              pengetahuanItem?.tipe_klinik_khusus === 'UTAMA'
                ? pengetahuanItem?.children ?? []
                : pengetahuanItem?.parent
                ? [pengetahuanItem?.parent]
                : []
            }
            type={pengetahuanItem?.tipe_klinik_khusus}
            total={pengetahuanItem?.children_count}
            hideButton={
              pengetahuanItem?.tipe_klinik_khusus === 'UTAMA' &&
              pengetahuanItem?.pengetahuan_approval_peserta?.is_approved ===
                false
                ? true
                : false
            }
          />
        )}
        {pengetahuanItem?.jenis_pengetahuan === 'synchronized' ? (
          <ReviewDiskusiTabs readOnlyDiskusi={true} />
        ) : (
          <ReviewPengetahuan />
        )}
      </GridItem>
    </Grid>
  );
};

export default PengetahuanSelesaiSection;
